import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { OfferUrgency } from "../OfferUrgency";
export function IntroOffer() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-212" data-mp="1gcsyfv5gy9d5">
      <div className="mx-auto max-w-3xl text-center" data-id="element-213" data-mp="1gdb5lmto67zu">
        <p className="font-display text-base font-semibold uppercase tracking-wide text-sun" data-id="element-214" data-mp="1keeka5zzdxzh">Your introductory offer</p>
        <h2 className="mt-2 font-display text-[2.2rem] font-bold leading-[1.08] sm:text-5xl" data-id="element-215" data-mp="np5f0jfxpos3">
          Get the Complete Collection for <span className="text-sun" data-id="element-216" data-mp="skulz7uaa7yf">$27 USD</span>
        </h2>
        <p className="mt-4 text-lg text-white/85" data-id="element-217" data-mp="wnhdt8qyfsvm">The introductory offer includes all six volumes and all five bonus resource packs.</p>
        <CtaButton label="Get the complete system" className="mt-8" dark data-id="element-218" data-mp="11hdckdf1ljru" />
        <OfferUrgency dark data-id="element-219" data-mp="4wuvm90vwjkd" />
      </div>

      <div className="mx-auto mt-16 max-w-3xl rounded-[2rem] bg-white p-6 text-navy sm:p-10" data-id="element-220" data-mp="8yy913745y8a">
        <p className="flex items-center gap-2 font-display text-base font-semibold uppercase tracking-wide text-teal-dark" data-id="element-221" data-mp="8wlkg76uopm9">
          <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-222" data-mp="3l90d8xwaz1nz" />
          Your purchase decision
        </p>
        <h3 className="mt-2 font-display text-2xl font-bold leading-tight sm:text-3xl" data-id="element-223" data-mp="3gi1w5w3hpzjo">
          Practical Resources to Complement Your Professional Workflow
        </h3>
        <div className="mt-4 space-y-3 text-base leading-relaxed text-ink-soft" data-id="element-224" data-mp="36kdxww6oe9wr">
          <p data-id="element-225" data-mp="36iayxmnjp6fw">
            The Pediatric OT Planning System™ is a digital educational and organizational resource collection. It is intended to help you organize planning tasks using reusable templates.
          </p>
          <p data-id="element-226" data-mp="2sl4gxuanbbrq">
            It does not guarantee clinical, financial, or professional outcomes and does not replace clinical judgment, individualized assessment, validated assessment tools, or required documentation systems.
          </p>
        </div>
        <CtaButton label="Get access for $27" className="mt-8" data-id="element-227" data-mp="qu16p64o3z7p" />
      </div>
    </section>;
}